import styled from '@emotion/styled';
import { Card } from '@mui/material';

const MatchCardContainer = styled(Card)`
    max-width: ${({ theme }) => theme.spacing(52.5)};
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    padding: ${({ theme }) => theme.spacing(2)};
    gap: ${({ theme }) => theme.spacing(2)};
    justify-content: flex-start;
`;

export { MatchCardContainer };
